import script from "./PersonalisCare.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalisCare.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalisCare.vue?vue&type=style&index=0&id=97380d52&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97380d52"]])

export default __exports__